export const VUE_FIREBASE_FUNCTIONS_URL = process.env.VUE_FIREBASE_FUNCTIONS_URL
export const VUE_AUTH_URL = process.env.VUE_APP_AUTH_URL
export const VUE_APP_API_URL = process.env.VUE_APP_API_URL
export const VUE_GOOGLE_CLIENT_ID = process.env.VUE_APP_CLIENT_ID

